import { action, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { DaVinciBusinessPartnersForm } from '../forms';
import { DaVinciStore } from 'modules/davinci/stores';

class DaVinciBusinessPartnersViewStore extends BaseViewStore {
	form = new DaVinciBusinessPartnersForm();

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.listStore = new DaVinciStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = () => {
		this.tableData = {
			columns: [
				{
					key: 'id',
					title: 'DAVINCIBUSINESSPARTNERS.ID',
				},
				{
					key: 'description',
					title: 'DAVINCIBUSINESSPARTNERS.NAME',
				},
			],
		};
	};

	@action.bound
	onSearchChange = async event => {
		if (event.key === 'Enter' && event.currentTarget.value.length != 0) {
			try {
				this.suspend();
				this.data = await this.listStore.getBusinessPartners(
					this.modalParams.data.selectedField.value.warehouseOrganizationInfoId,
					event.currentTarget.value
				);
			} catch (error) {
				this.rootStore.notificationStore.error(['MESSAGES.DAVINCIBUSINESSPARTNERS.ERROR']);
			}
			this.resume();
		}
	};

	@action.bound
	onBusinessPartnerSelect = id => {
		this.modalParams.data.selectedField.$('vendorId').set('value', id);
		this.modalParams.close();
	};
}

export default DaVinciBusinessPartnersViewStore;



// WEBPACK FOOTER //
// ./src/modules/seller/stores/DaVinciBusinessPartnersViewStore.js